exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"minimize\":true,\"sourceMap\":true}!../../../node_modules/postcss-loader/lib/index.js??postcss!./myTable.css"), "");

// module
exports.push([module.id, ".my__table-caption,.my__table-emptyView{color:var(--primary-color)}.my__table-emptyView{margin-top:10px}.my__table-header-cell{color:var(--primary-color);font-size:1rem}", "", {"version":3,"sources":["/Users/CKajouii/Sites/guarentee/guarentee/src/components/myTable/myTable.css"],"names":[],"mappings":"AAMA,wCAHE,0BAA4B,CAM7B,AAHD,qBACE,eAAiB,CAElB,AAED,uBACE,2BAA4B,AAC5B,cAAgB,CACjB","file":"myTable.css","sourcesContent":["@import url('./myTable.css');\n\n.my__table-caption {\n  color: var(--primary-color);\n}\n\n.my__table-emptyView {\n  margin-top: 10px;\n  color: var(--primary-color);\n}\n\n.my__table-header-cell {\n  color: var(--primary-color);\n  font-size: 1rem;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/myTable/myTable.css
// module id = 2413
// module chunks = 0